import React from "react";

const chartOptions = [
    { value: "pie", label: "Pie Chart" },
    { value: "bar", label: "Bar Chart" },
    { value: "line", label: "Line Chart" },
    { value: "area", label: "Area Chart" },
];

const ValetActivityChartSelector = ({ selectedChart, onChange }) => (
    <div
        className="dashboard-location-form"
        style={{ margin: 0 }}>
        <label
            htmlFor="chart-type-select"
            className="dashboard-location-label">
            Chart Type:
        </label>
        <select
            id="chart-type-select"
            className="dashboard-location-select"
            value={selectedChart}
            onChange={(e) => onChange(e.target.value)}>
            {chartOptions.map((opt) => (
                <option
                    key={opt.value}
                    value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </select>
    </div>
);

export default ValetActivityChartSelector;
